import ProjectActionPage from "pages/projects/ProjectActionPage";
import ResultsPage from "pages/projects/ResultsPage";
import SchedulePage from "pages/projects/SchedulePage";
import React, { useState } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { Project, Company } from "types";
import { SelectedProjectContext, SelectedCompanyContext } from "utils/context";

export default function ProjectRoutes() {
    const [selectedProject, setSelectedProject] = useState<Project | undefined>();
    const [selectedCompany, setSelectedCompany] = useState<Company>();
    return (
        <SelectedProjectContext.Provider value={[selectedProject, setSelectedProject]}>
            <SelectedCompanyContext.Provider value={[selectedCompany, setSelectedCompany]}>
                <Routes>
                    <Route path="*" element={<Outlet />}>
                        <Route path="runs" element={<ResultsPage />} />
                        <Route path="schedules" element={<SchedulePage />} />
                        <Route path="actions" element={<ProjectActionPage />} />
                    </Route>
                </Routes>
            </SelectedCompanyContext.Provider>
        </SelectedProjectContext.Provider>
    );
}
